import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import styles from './ErrorPanel.module.scss';

export interface Props {
  title?: string,
  description?: string
}

export default function ErrorPanel({ title, description }: Props) {
  const { t } = useTranslation();

  return (
    <Stack
      data-testid="ErrorPanel-test-id"
      className={styles.error}
      justifyContent="center"
      alignItems="center"
      spacing={3}
    >
      <Typography
        className={styles.error__title}
        component="h1"
        variant="h5"
      >
        { title ?? t('errors.generic.title') }
      </Typography>

      <Typography>
        { description ?? t('errors.generic.description') }
      </Typography>
    </Stack>
  );
}
